import React from 'react';
import PriceComponent from "@/components/ui/Price";
import Counter from '@/components/Counter';
import Button from "@/components/ui/button";
import { toast_configs } from "@core/constants/toast_configs";
import { show_mutation_error_toast } from "@/helpers/mutationErrors";
import NotifyProduct from '@/components/NotifyProduct';


const AddToCartMobile = ({
    selected_mix_variant,
    check_product_availability,
    check_product_offer,
    add_to_cart_handler,
    add_to_cart_loading,
    item_count_in_cart,
    mix_variant_limit_min,
    mix_variant_limit_max,
    change_count_items_in_cart_handler,
    remove_from_cart_handler,
    remove_from_cart_loading,
    add_product_to_notifications_handler,
    is_notify,
}) => {

    const is_available = check_product_availability(selected_mix_variant);
    const has_offer = check_product_offer(selected_mix_variant);
    const discountPercent = selected_mix_variant?.price?.discount_percent

    const removeHandler = (e) => {
        remove_from_cart_handler(e, {
            succes_callback: () => { },
            error_callback: show_mutation_error_toast,
        });
    };

    const changeCountHandler = (value) => {
        change_count_items_in_cart_handler({
            count: value,
            succes_callback: () => { },
            error_callback: show_mutation_error_toast,
        });
    };

    const addToCart = async (e) => {
        await add_to_cart_handler(e, {
            count: mix_variant_limit_min() || 1,
            // افزودن موفق دیگر توست نمی‌دهد؛ تبدیل شدن دکمه به شمارنده خودش
            // بازخورد کافی است. فقط خطا همچنان اطلاع‌رسانی می‌شود.
            success_callback: () => { },
            error_callback: () =>
                toast_configs("خطا در افزودن به سبد خرید", "error", {
                    className: "custome_toastify",
                    position: "bottom-center",
                    autoClose: 2000,
                }),
        });
    };

    return (

        <>
            <div className='flex items-end justify-between'>

                {/* stock */}
                <div>
                    {is_available &&
                        (selected_mix_variant?.details?.count < 100 ||
                            (
                                selected_mix_variant?.details?.limit_max &&
                                selected_mix_variant?.details?.limit_max < 100
                            )
                        ) && (
                            <div className="flex items-center gap-1 text-xs font-bold text-jmt-red-700">

                                <p className="flex items-center gap-1">
                                    <span> تنها </span>
                                    {
                                        selected_mix_variant?.details?.count < 100
                                            ? selected_mix_variant?.details?.count
                                            : selected_mix_variant?.details?.limit_max
                                    }

                                    <span>  عدد باقیمانده </span>
                                </p>
                            </div>
                        )}
                </div>

                {/* price */}
                {is_available ?
                    <div className="space-y-1 text-left">

                        {has_offer ? (
                            <>
                                <div className="flex items-center justify-end gap-1">

                                    {/* old price */}
                                    <PriceComponent
                                        price={selected_mix_variant?.price?.price}
                                        className="text-jmt-neutral-400 line-through text-sm [&>.price-currency]:hidden" />

                                    {/* offer badg */}
                                    {discountPercent && (
                                        <div className="flex items-center justify-center bg-jmt-red-700 rounded-md px-1 py-px ">
                                            <span className="text-jmt-white text-xs font-bold">
                                                {discountPercent}٪
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* final price */}
                                <div className="flex items-center justify-end gap-1">

                                    <PriceComponent
                                        price={selected_mix_variant?.price?.main_price}
                                        className="font-bold text-lg text-neutral-900"
                                    />
                                </div>

                            </>
                        ) : <PriceComponent
                            price={selected_mix_variant?.price?.main_price}
                            className="font-bold text-base text-neutral-900"
                        />}


                    </div>

                    : <div className="w-full flex flex-col items-start">

                        <div className="text-jmt-neutral-800 font-bold text-sm pb-4">
                            این کالا فعلا موجود نیست، با فشردن دکمه زیر به محض موجود شدن، به شما خبر می‌دهیم.
                        </div>

                        <NotifyProduct
                            add_product_to_notifications_handler={add_product_to_notifications_handler}
                            mix_variant={selected_mix_variant}
                            is_notify={is_notify} />

                    </div>
                }
            </div>

            {/* add to cart */}
            {is_available && (
                <div className="w-full mt-4">
                    {item_count_in_cart() ? (
                        <Counter
                            min={mix_variant_limit_min()}
                            max={mix_variant_limit_max()}
                            removeHandler={removeHandler}
                            quantity={item_count_in_cart()}
                            onChange={changeCountHandler}
                            loading={add_to_cart_loading[selected_mix_variant?.keys]}
                            remove_from_cart_loading={remove_from_cart_loading[selected_mix_variant?.keys]}
                        />
                    ) : (


                        <Button
                            text={" افزودن به سبد خرید"}
                            onClick={addToCart}
                            loading={add_to_cart_loading[selected_mix_variant?.keys]}
                            color_type="primary"
                            className="whitespace-nowrap w-full" />
                    )}
                </div>
            )}

        </>
    );
};

export default AddToCartMobile;

